import { getAddress } from '@ethersproject/address'
export function isAddress(address) {
    try {
        getAddress(address);
        return true;
    } catch (error) { }
    return false;
}